import { Capitalize, formatDateAndTime } from 'lib/helpers/utility';

import Badge from 'components/shared/Badge/Badge';

export const cols = [
  { field: 'id', headerName: 'ID', maxWidth: 100 },
  {
    field: 'practice',
    headerName: 'Practice',
    valueFormatter: ({ value }) => {
      if (value?.name) {
        return value?.name;
      } else {
        return 'Admin User';
      }
    }
  },
  {
    field: 'user',
    headerName: 'User',
    valueFormatter: ({ data }) => {
      const userObj = data?.user || data?.admin;
      if (!userObj) return '-';
      return `${userObj?.f_name || ''} ${userObj?.l_name || ''}`.trim();
    }
  },
  { field: 'model', headerName: 'Model' },
  {
    field: 'status',
    headerName: 'Status',
    valueFormatter: ({ value }) => Capitalize(value),
    cellRenderer: ({ value }) =>
      value == 'complete' ? (
        <div className="flex h-full items-center justify-center">
          <Badge text="Complete" color="success" />
        </div>
      ) : value == 'initiated' ? (
        <div className="flex h-full items-center justify-center">
          <Badge text="Initiated" color="danger" />
        </div>
      ) : (
        <div className="flex h-full items-center justify-center">
          <Badge text="Processing" color="primary" />
        </div>
      )
  },
  { field: 'prompt_template_id', headerName: 'Prompt ID', maxWidth: 150 },
  { field: 'prompt_template_version', headerName: 'Prompt Version', maxWidth: 150 },
  { field: 'token_count', headerName: 'Req Token Count' },
  { field: 'response_token_count', headerName: 'Res Token Count' },
  { field: 'request', headerName: 'Request Body' },
  { field: 'response', headerName: 'Response Body' },
  {
    field: 'created_at',
    headerName: 'Requested At',
    valueFormatter: ({ value }) => formatDateAndTime(value)
  }
];

export const DEFAULT_COLUMN_DEFS = {
  enableRowGroup: true
};
export const GRID_OPTIONS = {
  animateRows: true,
  rowGroupPanelShow: 'never',
  enableRangeSelection: true,
  showOpenedGroup: true,
  suppressAggFuncInHeader: true,
  autoGroupColumnDef: {
    pinned: 'left',
    sortable: false
  }
};
